module.exports = __webpack_public_path__ + "img/0.10c35d17.png";